import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

// Components that guard against navigating away with unsaved changes implement this. The guard delegates
// to the component so the confirm dialog + dirty check live where the form state does.
export interface ComponentCanDeactivate {
  canDeactivate(): boolean | Observable<boolean>;
}

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    return component?.canDeactivate ? component.canDeactivate() : true;
  }
}
